import {
  IAdapterData,
  ICountryConfigData,
  ICountryConfigResponse,
  ICountryData,
  ICurrencyData,
  IUserDetailData,
} from "@/entities";
import { IPageResponse } from "@/services";
import { IState, Locale } from "../store.types";
import { IMutations } from "@/store";
import { i18n } from "@/i18n";
import { ISolCustomerCurrency } from "@/entities/sol_customer/currency/currency.types";

export const mutations: IMutations = {
  SET_CURRENT_LOCALE(state: IState, payload: Locale): void {
    state.locale = payload;
  },
  SET_CURRENT_LOCATION(state: IState, payload: string): void {
    state.currentLocation = payload;
  },
  SET_SIGNED_IN(state: IState, payload: boolean): void {
    state.signedIn = payload;
  },
  SET_LOGGED_USER(state: IState, payload: IUserDetailData): void {
    state.loggedUser = payload;
  },
  SET_DISCLAIMER(state: IState, payload: string): void {
    state.disclaimer = payload;
  },
  SET_USERS_GUIDE(state: IState, payload: string): void {
    state.usersGuide = payload;
  },
  SET_COUNTRY_CONFIG(state: IState, payload: ICountryConfigData): void {
    state.countryConfig = payload;
  },
  SET_CASH_COUNTRY_CONFIG(state: IState, payload: ICountryConfigResponse): void {
    state.cashCountryConfig = payload;
  },
  SET_COUNTRIES_PAGE(state: IState, payload: IPageResponse<ICountryData>): void {
    state.countriesPage = payload;
    const content = state.countriesPage?.content;

    if (content) {
      content.forEach(
        (value) => (value.name = i18n.t(`country.${value?.code?.toLowerCase()}`).toString())
      );

      content.sort((a, b) => {
        if ((a.name || "") < (b.name || "")) {
          return -1;
        }
        return (b.name || "") > (a.name || "") ? 1 : 0;
      });
    }
  },
  SET_ASSIGNABLE_ADAPTERS(state: IState, payload: IAdapterData[]): void {
    state.assignableAdapters = payload;
  },
  SET_CURRENCIES_PAGE(state: IState, payload: IPageResponse<ICurrencyData>): void {
    state.currenciesPage = payload;
  },
  SET_SOLCUSTOMER_CURRENCIES(state: IState, payload: ISolCustomerCurrency[]): void {
    state.solCustomerCurrencies = payload;
  },
};
